import { Injectable } from '@angular/core';
import { KeyValService } from './key-val.service';

/** Lädt und hält die Avatar-Bild-URLs von Bot und Nutzer vor. */
@Injectable({
  providedIn: 'root'
})
export class AvatarImageService {
  private botAvatarUrl: string = '';
  private userAvatarUrl: string = '';

  constructor(
    protected keyvalService: KeyValService
  ) { }

  /** Lädt sowohl Bot- als auch Nutzer-Avatarbild aus dem KeyVal-Speicher. */
  public async loadAvatarUrls() {
    await this.loadBotAvatarUrl();
    await this.loadUserAvatarUrl();
  }

  /** Lädt das Bot-Avatarbild aus dem KeyVal-Speicher. */
  public async loadBotAvatarUrl() {
    this.botAvatarUrl = await this.keyvalService.getKeyValEntry('botAvatar', 'avatarImage') as string | undefined ?? '';

  }

  /** Lädt das Nutzer-Avatarbild aus dem KeyVal-Speicher. */
  public async loadUserAvatarUrl() {
    this.userAvatarUrl = await this.keyvalService.getKeyValEntry('userAvatar', 'avatarImage') as string | undefined ?? '';
  }

  /**
   * Gibt die zuletzt geladene Bot-Avatar-URL zurück.
   * @returns Die Bot-Avatar-URL, oder ein leerer String.
   */
  public getBotAvatar() {
    return this.botAvatarUrl;
  }

  /**
   * Gibt die zuletzt geladene Nutzer-Avatar-URL zurück.
   * @returns Die Nutzer-Avatar-URL, oder ein leerer String.
   */
  public getUserAvatar() {
    return this.userAvatarUrl;
  }

}
